import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FindControlBehaviorConfigDto, FindControlBehaviorConfigResultDto } from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FindControlBehaviorConfigurationRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  routePrefix = 'findcontrolbehavior';

  getFindControlBehaviorConfiguration(pk: string): Observable<FindControlBehaviorConfigDto> {
    const endpointUrl =  `${this.routePrefix}/${pk}/configuration`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  putFindControlBehaviorConfiguration(
    findControlBehaviorConfig: FindControlBehaviorConfigDto,
  ): Observable<FindControlBehaviorConfigResultDto> {
    const pk = findControlBehaviorConfig.FindControlBehavior.FindControlBehaviorUid;
    const endpointUrl = `${this.routePrefix}/${pk}/configuration`;
    return this.httpClientService.sendPutRequest(endpointUrl, findControlBehaviorConfig);
  }
}
